import type { DropdownOption } from "@waterly/frontend-components";

import { ALL_STATES_ID } from "../../ui/Overview/SystemTable";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type OverviewSystemFilterState = {
  overviewFavoritesFilter: boolean;
  overviewStateFilter: DropdownOption | string;
};

type OverviewSystemFilterActions = {
  toggleOverviewFavoritesFilter: () => void;
  setOverviewStateFilter: (input: DropdownOption) => void;
};

const initialState: OverviewSystemFilterState = {
  overviewFavoritesFilter: false,
  overviewStateFilter: ALL_STATES_ID,
};

export const createOverviewSystemFilterSlice: WaterlyAppStateCreator<
  OverviewSystemFilterActions,
  OverviewSystemFilterState
> = (set, get) => ({
  ...initialState,
  toggleOverviewFavoritesFilter: () => {
    const { overviewFavoritesFilter } = get();
    set({ overviewFavoritesFilter: !overviewFavoritesFilter });
  },
  setOverviewStateFilter: (input) => {
    set({ overviewStateFilter: input });
  },
});
